import React, { createContext, useContext, useState, useCallback } from 'react';
import { Alert, Snackbar } from '@mui/material';

const ErrorContext = createContext(null);

export const ErrorProvider = ({ children }) => {
  const [error, setError] = useState(null);
  const [severity, setSeverity] = useState('error');

  const showError = useCallback((message, sev = 'error', timeout = 5000) => {
    // Ensure message is a string
    const errorMessage = typeof message === 'string'
      ? message
      : (message?.message || message?.toString() || 'An error occurred');

    setError(errorMessage);
    setSeverity(sev);

    if (timeout) {
      setTimeout(() => {
        setError(null);
      }, timeout);
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return (
    <ErrorContext.Provider value={{ showError, clearError }}>
      {children}
      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        onClose={clearError}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={clearError} severity={severity} sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>
    </ErrorContext.Provider>
  );
};

export const useError = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useError must be used within an ErrorProvider');
  }
  return context;
};